// extracted by mini-css-extract-plugin
module.exports = {"content":"inner-wrapper-module--content--3oLQa"};